import React from "react";
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import DashboardCard from "./DashboardCard";

export default function TicketChart({ data = [], title, subtitle, action, emptyState }) {
  const isEmpty = data.every((item) => Number(item?.count || 0) === 0);

  return (
    <DashboardCard subtitle={subtitle} title={title} action={action}>
      {isEmpty ? (
        emptyState
      ) : (
        <ResponsiveContainer width="100%" height={380}>
          <BarChart data={data} margin={{ top: 12, right: 12, left: -12, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#dbe4f0" vertical={false} />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#5b6574" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 12, fill: "#5b6574" }} axisLine={false} tickLine={false} allowDecimals={false} />
            <Tooltip
              cursor={{ fill: "rgba(37,99,235,0.06)" }}
              contentStyle={{
                borderRadius: "14px",
                border: "1px solid #d9e2ef",
                boxShadow: "0 18px 38px rgba(15,23,42,0.12)",
              }}
              formatter={(value) => [value, "Tickets"]}
            />
            <Bar dataKey="count" radius={[10, 10, 0, 0]} maxBarSize={56}>
              <LabelList dataKey="count" position="top" fill="#334155" fontSize={12} fontWeight={700} />
              {data.map((entry) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </DashboardCard>
  );
}
